module.exports = __webpack_public_path__ + "static/pai-c932e1908295a6e82616369285ada6c2.jpg";